import { Component, OnInit } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Router } from '@angular/router';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { SentmessageModel } from 'projects/core/src/lib/models/sentmessage.model';

@Component({
  selector: 'app-sentmessage-list',
  templateUrl: './sentmessage-list.component.html',
  styleUrls: ['./sentmessage-list.component.scss']
})
export class SentmessagesListComponent extends BaseList implements OnInit {

  public sentmessages: Array<SentmessageModel> = [];
  public apiUrl = '/contents/sentmessages';

  public messageVisible = false;
  public messageSelected: SentmessageModel = null;

  protected rightLoad = 'admin.sentmessage.list';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('sentmessages').subscribe({
      next: (sentmessages: any) => {
        this.sentmessages = [];
        sentmessages.data.forEach((ac: any) => {
          this.sentmessages.push(new SentmessageModel().deserialize(ac));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

  public onShowContent(sentmessage: SentmessageModel): void {
    this.messageVisible = true;
    this.messageSelected = sentmessage;
  }

}
